<template>
  <el-date-picker
    :value="value"
    type="date"
    placeholder="选择日期"
    format="yyyy-MM-dd"
    value-format="yyyy-MM-dd"
    clearable
    :editable="false"
    class="portal-el-date"
    :append-to-body="appendToBody"
    :popper-class="popperClass"
    v-bind="$attrs"
    @input="$emit('input', $event)"
  />
</template>

<script>
/**
 * 全站统一日期选择：Element UI 日历面板 + yyyy-MM-dd，与中文语言包配合显示「年月 / 周一…日」。
 */
export default {
  name: "PortalDatePicker",
  inheritAttrs: false,
  props: {
    value: {
      default: ""
    },
    appendToBody: {
      type: Boolean,
      default: true
    },
    popperClass: {
      type: String,
      default: "portal-date-picker-popper"
    }
  }
};
</script>

<style>
.portal-date-picker-popper.el-picker-panel {
  z-index: 100010 !important;
}
</style>
